import React, { useState } from "react";
import i18n from "../lib/i18n";
import ChartSelector from "./ChartSelector";
import TimeBarChart from "./TimeBarChart";
import UIBox from "./UIBox";
import { preferredEnergySavingsColors } from "../lib/chartHelpers";

const SustainabilityPage = ({ series }) => {
  const [activeTab, setActiveTab] = useState("by_energy_savings");

  const tabs = [
    {
      key: "by_energy_savings",
      label: i18n.t("js.components.sustainability_page.by_energy_savings"),
      component: (
        <div className="c-layout-card__content">
          <div id="graph-yearly">
            <TimeBarChart
              series={series.energy_savings}
              devicePixelRatio={2}
              formatter="energy"
              preferredColors={preferredEnergySavingsColors()}
              reverseStackingOrder={true}
            />
          </div>
        </div>
      ),
    },
    {
      key: "by_yearly_emissions",
      label: i18n.t("js.components.sustainability_page.by_yearly_emissions"),
      component: (
        <div className="c-layout-card__content">
          <div id="graph-yearly">
            <TimeBarChart
              series={series.emissions}
              devicePixelRatio={2}
              formatter="emissions"
            />
            <small
              className="text-muted"
              dangerouslySetInnerHTML={{
                __html: i18n.t(
                  "js.components.sustainability_page.emission_calculation_info"
                ),
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <UIBox>
        <ChartSelector
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />

        <div data-cy={`graph-actions-${activeTab}`}>
          {tabs.find((tab) => tab.key === activeTab).component}
        </div>
      </UIBox>
    </>
  );
};

export default SustainabilityPage;
